import {reactive} from 'vue';
export const store = reactive({
    currentId: '',
    update(key,value) {
      this[key] = value;
    }
  })